/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa60a12a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-mouse-move-x", "data-mouse-move-y", "data-mouse-move-source-type"];
const _hoisted_2 = ["viewBox"];
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<defs data-v-aa60a12a><linearGradient id=\"diagonal-stripe\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\" spreadMethod=\"repeat\" data-v-aa60a12a><stop offset=\"0%\" stop-color=\"rgba(0, 0, 0, 0.15)\" data-v-aa60a12a></stop><stop offset=\"25%\" stop-color=\"rgba(0, 0, 0, 0.15)\" data-v-aa60a12a></stop><stop offset=\"25%\" stop-color=\"transparent\" data-v-aa60a12a></stop><stop offset=\"50%\" stop-color=\"transparent\" data-v-aa60a12a></stop><stop offset=\"50%\" stop-color=\"rgba(0, 0, 0, 0.15)\" data-v-aa60a12a></stop><stop offset=\"75%\" stop-color=\"rgba(0, 0, 0, 0.15)\" data-v-aa60a12a></stop><stop offset=\"75%\" stop-color=\"transparent\" data-v-aa60a12a></stop><stop offset=\"100%\" stop-color=\"transparent\" data-v-aa60a12a></stop></linearGradient><pattern id=\"non-print-pattern\" width=\"0.35\" height=\"0.35\" patternUnits=\"userSpaceOnUse\" data-v-aa60a12a><rect width=\"0.35\" height=\"0.35\" fill=\"url(#diagonal-stripe)\" data-v-aa60a12a></rect></pattern><filter id=\"glow\" x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" data-v-aa60a12a><feGaussianBlur stdDeviation=\"0.05\" result=\"coloredBlur\" data-v-aa60a12a></feGaussianBlur><feMerge data-v-aa60a12a><feMergeNode in=\"coloredBlur\" data-v-aa60a12a></feMergeNode><feMergeNode in=\"SourceGraphic\" data-v-aa60a12a></feMergeNode></feMerge></filter></defs>", 1);
const _hoisted_4 = ["id", "d", "fill", "data-name"];
const _hoisted_5 = ["xlink:href"];
import { useConfigurationStore } from '@/stores/configurationModule';
import { nextTick, onMounted } from 'vue'; // @NOTE: Test if it needs import
import { useFabricStore } from '@/stores/fabricModule';
import { PPI } from '@/box/constants';
export default {
  __name: 'EditorPanelOverlay',
  props: {
    printSide: {
      require: true,
      type: String,
      default: 'outside'
    },
    canvasDisplayWidth: {
      type: Number
    },
    canvasDisplayHeight: {
      type: Number
    },
    mouseX: {
      type: Number
    },
    mouseY: {
      type: Number
    },
    sourceType: {
      type: String
    }
  },
  setup(__props) {
    const fabricStore = useFabricStore();
    const {
      canvasScaleFactor
    } = storeToRefs(fabricStore);
    const configurationStore = useConfigurationStore();
    const {
      setHoveredPanel,
      setActivePanel,
      setIsActivePanelInside,
      setIsHoveredPanelInside,
      setActiveCanvas
    } = configurationStore;
    const {
      hoveredPanel,
      activePanel,
      isActivePanelInside,
      isHoveredPanelInside,
      box,
      fabricCanvases
    } = storeToRefs(configurationStore);
    const $eventBus = inject('bus');
    const panelRefs = ref([]); // @NOTE: not used

    // @NOTE: Rethink handling this inside watch
    const activePanelRef = ref(null);
    const hoveredPanelRef = ref(null);
    const panelEl = ref([]);
    const svgEl = ref(null);
    const props = __props;

    // @TODO: Watch to track hovered panel
    // @NOTE: Hovered State: Znamo koordinate, ali ne znamo da li su za unutrašnji ili spoljašnji panel
    const mousePosition = computed(() => {
      return {
        x: props.mouseX,
        y: props.mouseY
      };
    });
    const panels = computed(() => {
      return box.value.panels;
    });
    const panelClasses = panel => {
      const classes = [];
      if (props.printSide === 'outside' && panel.print === false || props.printSide === 'inside' && panel.printInside === false) {
        classes.push('non-print');
      }
      if (props.printSide === 'inside') {
        classes.push('inside-print');
      }
      return classes;
    };
    function transformMousePosition(x, y) {
      const point = svgEl.value.createSVGPoint();
      point.x = x / PPI;
      point.y = y / PPI;
      // return point.matrixTransform(svgEl.value.getScreenCTM());
      return point;
    }
    function isPointInPath(path, x, y) {
      const point = svgEl.value.createSVGPoint();
      point.x = x;
      point.y = y;
      point.matrixTransform(svgEl.value.getScreenCTM().inverse());
      return path.isPointInStroke(point) || path.isPointInFill(point);
    }
    function getPanelNameByCoordinates(x, y, printSide) {
      for (const path of panelEl.value) {
        const targetX = printSide === 'inside' || props.printSide === 'inside' ? props.canvasDisplayWidth - x : x;
        const calculatedX = targetX / PPI * canvasScaleFactor.value;
        const calculatedY = y / PPI * canvasScaleFactor.value;
        if (isPointInPath(path, calculatedX, calculatedY)) {
          return path.dataset.name;
        }
      }
      return null;
    }
    async function handleOnCanvasMouseClick({
      event,
      printSide
    }) {
      if (printSide !== props.printSide) {
        return;
      }
      const panelName = getPanelNameByCoordinates(event.offsetX, event.offsetY, printSide);
      if (panelName) {
        const panelIndex = panels.value.findIndex(p => p.name === panelName);
        if (panelIndex > -1) {
          const panel = panels.value[panelIndex];
          const isPrintable = printSide === 'inside' ? panel.printInside : panel.print;
          if (isPrintable) {
            // @NOTE: This is inside this condition because setting active panel to null
            // will deselect active panel if user clicks on not printable panel
            setActivePanel(); // @NOTE: DIRTY FIX
            await nextTick();

            // @NOTE - END

            setActivePanel(panel);
          }
        }
      } else {
        // Deselect panel on canvas click
        setActivePanel();
      }
    }
    $eventBus.$on('canvas-mouse-click', handleOnCanvasMouseClick);
    function getIsPanelPrintable(panel, printSide) {
      if (printSide === 'inside') {
        return panel.printInside;
      }
      return panel.print;
    }

    // Hovered and active panel refs
    function updatePanelRef(panel, panelRef, isPanelInside) {
      panelRef.value = null; // Default to null to handle cases where conditions don't match

      if (panel) {
        const panelIndex = panels.value.findIndex(p => p.name === panel.name);
        if (panelIndex > -1) {
          const side = isPanelInside.value ? 'inside' : 'outside';
          if (props.printSide === side) {
            panelRef.value = `${props.printSide}-${panelIndex}`;
          }
        }
      }
    }

    // Watch for changes in activePanel
    watch(activePanel, panel => {
      requestAnimationFrame(() => {
        updatePanelRef(panel, activePanelRef, isActivePanelInside);
      });
      // updatePanelRef(panel, activePanelRef, isActivePanelInside);
    });

    // Watch for changes in hoveredPanel
    watch(hoveredPanel, panelName => {
      requestAnimationFrame(() => {
        const panel = panelName ? {
          name: panelName
        } : null; // Create a panel object if panelName is not null
        updatePanelRef(panel, hoveredPanelRef, isHoveredPanelInside);
      });
      // const panel = panelName ? { name: panelName } : null; // Create a panel object if panelName is not null
      // updatePanelRef(panel, hoveredPanelRef, isHoveredPanelInside);
    });
    function updateOnMousePositionChanged(x, y) {
      const panelName = getPanelNameByCoordinates(x, y);
      if (panelName) {
        const panelIndex = panels.value.findIndex(p => p.name === panelName);
        if (panelIndex > -1) {
          setIsHoveredPanelInside(props.printSide === 'inside');
          setHoveredPanel(panelName);
        }
      } else {
        setHoveredPanel(null);
      }
    }
    watch(mousePosition, ({
      x,
      y
    }) => {
      requestAnimationFrame(() => updateOnMousePositionChanged(x, y));
    });
    const overlyRotateStyles = computed(() => {
      return props.printSide === 'inside' ? `transform: scaleX(-1); transform-origin: 'center'` : '';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "editorPanelOverlay",
        style: _normalizeStyle(_unref(overlyRotateStyles)),
        "data-mouse-move-x": _unref(mousePosition).x,
        "data-mouse-move-y": _unref(mousePosition).y,
        "data-mouse-move-source-type": __props.sourceType
      }, [(_openBlock(), _createElementBlock("svg", {
        ref_key: "svgEl",
        ref: svgEl,
        width: "100%",
        height: "100%",
        viewBox: `0 0 ${_unref(box).getDocumentWidth()} ${_unref(box).getDocumentHeight()}`
      }, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(panels), (panel, index) => {
        return _openBlock(), _createElementBlock("path", {
          key: index,
          id: `${__props.printSide}-${index}`,
          ref_for: true,
          ref_key: "panelEl",
          ref: panelEl,
          d: panel.path,
          fill: getIsPanelPrintable(panel, __props.printSide) ? 'transparent' : 'url(#non-print-pattern)',
          stroke: "transparent",
          "stroke-width": "0.04",
          filter: "url(#glow)",
          "data-name": panel.name,
          class: _normalizeClass(["panel-overlay", [...panelClasses(panel), {
            active: _unref(activePanelRef) === `${__props.printSide}-${index}`,
            hovered: _unref(hoveredPanelRef) === `${__props.printSide}-${index}`
          }]])
        }, null, 10, _hoisted_4);
      }), 128)), _createElementVNode("use", {
        "xlink:href": `#${_unref(activePanelRef)}`
      }, null, 8, _hoisted_5)], 8, _hoisted_2))], 12, _hoisted_1);
    };
  }
};